if (!customElements.get("flash-sale")) {
  class FlashSale extends HTMLElement {
    connectedCallback() {
      this._hours = parseInt(this.dataset.hours, 10);
      this._autoClose = this.dataset.autoClose !== "false";
      this._position = this.dataset.position || "right";
      this._storageKey = `flash_sale_end_${this.id}`;
      this._configKey = `flash_sale_cfg_${this.id}`;
      this._shownKey = `flash_sale_shown_${this.id}`;
      this._interval = null;

      if (this._position === "left") this.classList.add("fs-pos-left");

      // If the time is 0 or invalid, the popup will not open at all, and the storage will be cleared.
      if (!this._hours || this._hours <= 0) {
        this._clearStorage();
        return;
      }

      this._endTime = this._getOrSetEndTime();

      const showOnce = this.dataset.showOnce === "true";
      if (showOnce && sessionStorage.getItem(this._shownKey)) return;
      if (this._endTime <= Date.now()) return;

      const delay = Math.max(0, parseInt(this.dataset.delay || "1", 10)) * 1000;
      setTimeout(() => this._open(), delay);

      this.querySelector(".flash-sale-close")?.addEventListener("click", () =>
        this._close(),
      );

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") this._close();
      });
    }

    _getOrSetEndTime() {
      const savedConfig = localStorage.getItem(this._configKey);
      const currentConfig = String(this._hours);

      // If the time was changed in Customize, reset the old timer.
      if (savedConfig !== currentConfig) {
        localStorage.removeItem(this._storageKey);
        localStorage.setItem(this._configKey, currentConfig);
      }

      const stored = localStorage.getItem(this._storageKey);
      if (stored) {
        const t = parseInt(stored, 10);
        if (t > Date.now()) return t;
      }

      const end = Date.now() + this._hours * 3600 * 1000;
      localStorage.setItem(this._storageKey, String(end));
      return end;
    }

    _clearStorage() {
      localStorage.removeItem(this._storageKey);
      localStorage.removeItem(this._configKey);
    }

    _pad(n) {
      return n < 10 ? "0" + n : String(n);
    }

    _tick() {
      const diff = Math.max(0, this._endTime - Date.now());
      const total = Math.floor(diff / 1000);
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;

      const elH = this.querySelector("#fs-hours");
      const elM = this.querySelector("#fs-minutes");
      const elS = this.querySelector("#fs-seconds");
      if (elH) elH.textContent = this._pad(h);
      if (elM) elM.textContent = this._pad(m);
      if (elS) elS.textContent = this._pad(s);

      if (diff === 0) {
        clearInterval(this._interval);
        if (this._autoClose) this._close();
      }
    }

    _open() {
      this.style.display = "block";
      this._tick();
      this._interval = setInterval(() => this._tick(), 1000);
    }

    _close() {
      this.classList.add("closing");
      setTimeout(() => {
        this.style.display = "none";
        this.classList.remove("closing");
      }, 350);
      clearInterval(this._interval);
      sessionStorage.setItem(this._shownKey, "1");
    }
  }

  customElements.define("flash-sale", FlashSale);
}
